const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.url = this.getAttribute("url");
    this.closeButton = this.querySelector("[data-close]");
    this.results = this.querySelector("[data-results]");
    this.openButton = this.closest("body").querySelector(
      ".header__search-icon",
    );

    this.mobileInput = this.closest("body").querySelector(
      "[data-mobile-input]",
    );
  }

  connectedCallback() {
    const handleSearch = (input) => {
      if (input.value == "") {
        this.results.innerHTML = "";
        document.body.classList.remove("header-search-has-results");
        return;
      }

      this.getSearchResults(input.value);
      window.trapFocus(this);
    };

    this.onTyping = debounce(handleSearch, 300);

    this.input.addEventListener("focus", (e) => {
      if (!this.classList.contains("typing")) {
        this.classList.add("typing");
        document.body.classList.add("header-search-open");
        window.openDimmer(this);
      }
    });

    this.input.addEventListener("input", (e) => {
      if (!this.classList.contains("typing")) {
        this.classList.add("typing");
        document.body.classList.add("header-search-open");
        window.openDimmer(this);
      }
      this.onTyping(this.input);
    });

    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.close();
    });

    this.openButton.addEventListener("click", (e) => {
      // e.stopPropagation();
      if (window.innerWidth < 960) return;

      if (!this.classList.contains("typing")) {
        this.classList.add("typing");
        document.body.classList.add("header-search-open");
        window.openDimmer(this);
      }

      this.input.focus();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        this.close();
      }
    });

    window.addEventListener("resize", (event) => {
      if (window.innerWidth < 960) {
        if (document.body.classList.contains("header-search-open")) {
          document.dispatchEvent(
            new CustomEvent("mobile-search:open", {
              bubbles: true,
              detail: {
                input: this.input.value,
              },
            }),
          );
        }
        this.close();
      }
    });

    document.addEventListener("header-search:open", (e) => {
      if (!this.classList.contains("typing")) {
        this.classList.add("typing");
        document.body.classList.add("header-search-open");
        this.input.value = e.detail.input;
        this.getSearchResults(e.detail.input);
      }
    });
  }

  close() {
    this.classList.remove("typing");
    document.body.classList.remove("header-search-open");
    document.body.classList.remove("header-search-has-results");
    this.input.value = "";
    this.results.innerHTML = "";
    window.closeDimmer(this);
    window.removeTrapFocus();
  }

  getSearchResults(q) {
    let requestResponse;

    fetch(
      `${this.url}?q=${q}&section_id=predictive-search&resources[limit]=10&resources[limit_scope]=each`,
    )
      .then((response) => {
        requestResponse = response;
        return response.text();
      })
      .then((text) => {
        if (!requestResponse.ok) {
          throw new Error(`${requestResponse.status}: ${text}`);
        }

        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;

        document.body.classList.add("header-search-has-results");
        this.results.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        console.error(error);
      });
  }
}

if (!customElements.get("header-search")) {
  customElements.define("header-search", HeaderSearch);
}
